<template>
  <div style="margin: 15px">
    <h4>异动调整:</h4>
    <div class="box">
      <el-form label-width="140px">
        <el-row>
          <el-col :span="8" :offset="3">
            <el-form-item label="异动名称：" required>
              <el-select v-model="change_item_id" placeholder="异动名称" :disabled="isDetail">
                <el-option v-for="item in options.change_item_options"
                           :key="item.id"
                           :value="item.id"
                           :label="item.name"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="生效月份：" required>
              <el-date-picker
                  :disabled="isEdit || isDetail"
                  v-model="active_date"
                  type="month"
                  value-format="YYYY-MM"
                  placeholder="选择日期时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :offset="3" :span="19">
            <el-form-item label="备注：">
              <el-input
                  :disabled="isDetail"
                  v-model="remark"
                  :autosize="{ minRows: 3, maxRows: 6 }"
                  type="textarea"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <h4>员工信息:</h4>
    <div class="box">
      <el-form label-width="140px">
        <el-row>
          <el-col :span="8" :offset="3">
            <el-form-item label="工号：" required>
              <el-input v-model="employee_no" placeholder="工号" @blur="employeeNoChange"
                        :disabled="isDetail || isEdit">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8" :offset="3">
            <el-form-item label="姓名：" required>
              <el-input v-model="employee_name" placeholder="姓名" disabled>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <el-form label-width="140px">
      <el-row>
        <el-col :span="3">
          <h4>
            <span>薪资调整: </span>
          </h4>
        </el-col>
      </el-row>
    </el-form>
    <div class="box">
      <el-form label-width="140px" :disabled="isEdit">
        <el-row>
          <el-col :span="8" :offset="4">
            <el-form-item label="异动前：">
            </el-form-item>
          </el-col>
          <el-col :span="6" :offset="3">
            <el-form-item label="异动后：">
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="8" :offset="3">
            <el-form-item label="基本薪资：">
              <el-input v-model="salary_change.before_salary_basic" disabled placeholder="基本薪资"/>
            </el-form-item>
          </el-col>
          <el-col :span="8" :offset="3">
            <el-form-item label="基本薪资：" required>
              <el-input v-model="salary_change.after_salary_basic" placeholder="基本薪资"
                        :disabled="isDetail" type="number"/>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="8" :offset="3">
            <el-form-item label="绩效工资：">
              <el-input v-model="salary_change.before_salary_merit" disabled placeholder="绩效工资"/>
            </el-form-item>
          </el-col>
          <el-col :span="8" :offset="3">
            <el-form-item label="绩效工资：" required>
              <el-input v-model="salary_change.after_salary_merit" placeholder="绩效工资"
                        :disabled="isDetail" type="number"/>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="8" :offset="3">
            <el-form-item label="岗位津贴：">
              <el-input v-model="salary_change.before_salary_job_allowance" disabled placeholder="岗位津贴"/>
            </el-form-item>
          </el-col>
          <el-col :span="8" :offset="3">
            <el-form-item label="岗位津贴：" required>
              <el-input v-model="salary_change.after_salary_job_allowance" placeholder="岗位津贴"
                        :disabled="isDetail" type="number"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8" :offset="3">
            <el-form-item label="奖金：">
              <el-input v-model="salary_change.before_salary_award" disabled placeholder="奖金"/>
            </el-form-item>
          </el-col>
          <el-col :span="8" :offset="3">
            <el-form-item label="奖金：" required>
              <el-input v-model="salary_change.after_salary_award" placeholder="奖金"
                        :disabled="isDetail" type="number"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8" :offset="3">
            <el-form-item label="餐补：">
              <el-input v-model="salary_change.before_salary_meal" disabled placeholder="餐补"/>
            </el-form-item>
          </el-col>
          <el-col :span="8" :offset="3">
            <el-form-item label="餐补：" required>
              <el-input v-model="salary_change.after_salary_meal" placeholder="餐补"
                        :disabled="isDetail" type="number"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8" :offset="3">
            <el-form-item label="话费补贴：">
              <el-input v-model="salary_change.before_salary_phone" disabled placeholder="话费补贴"/>
            </el-form-item>
          </el-col>
          <el-col :span="8" :offset="3">
            <el-form-item label="话费补贴：" required>
              <el-input v-model="salary_change.after_salary_phone" placeholder="话费补贴"
                        :disabled="isDetail" type="number"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <label style="margin-left: 5px;font-weight: bold">其它附件:</label>
    <el-row>
      <el-col :span="6" :offset="3">
        <el-form :disabled="isDetail">
          <kf-file-upload v-model="file_id" :init-file="fileList"
                          @fileChange="fileChange"
                          :limit="10" :showTotalCnt="true"></kf-file-upload>
        </el-form>
      </el-col>
    </el-row>

    <div style="display: flex;justify-content: center;margin-bottom: 20px">
      <el-button type="primary" @click="saveButton" v-if="!isDetail">保存</el-button>
    </div>
  </div>
</template>

<script>


export default {
  name: "EmployeeChangeRecordAdd",
  inject: ['$fn'],
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      CascaderProp: {
        emitPath: true,
        label: "name",
        value: "id"
      },
      isDetail: false,
      isEdit: false,
      change_item_id: '',
      options: {
        change_item_options: []
      },
      remark: '',
      employee_no: '',
      employee_name: '',
      active_date: '',
      salary_change: {
        before_salary_basic: '',
        after_salary_basic: '',
        before_salary_merit: '',
        after_salary_merit: '',
        before_salary_job_allowance: '',
        after_salary_job_allowance: '',
        before_salary_award: '',
        after_salary_award: '',
        before_salary_meal: '',
        after_salary_meal: '',
        before_salary_phone: '',
        after_salary_phone: '',
      },
      file_id: [],
      fileList: [],
      change_type: 'salary'
    }
  },
  methods: {

    //获取文件
    async getAttachments() {
      let params = {
        file_id: this.file_id
      }
      console.log('aaa', params)
      this.formData = await this.$http('fileService.getAttachments', params)
      if (this.formData) {
        this.fileList = this.formData.attachmentsList;
      }
    },

    async fileChange(ids) {
      if (ids.length <= 0) {
        return
      }
      this.file_id = ids;
    },

    async saveButton() {
      let flag = this.checkForm()
      if (!flag) {
        return
      }
      let params = {
        id: this.parentData.id,
        change_item_id: this.change_item_id,
        remark: this.remark,
        employee_no: this.employee_no,
        employee_name: this.employee_name,
        salary_change: this.salary_change,
        file_id: this.file_id,
        active_date: this.active_date,
        change_type: this.change_type
      }
      await this.$http("employeeChangeRecordService.saveEmpChangeRecord", params).then(() => {
        this.$message.success("保存成功！");
        this.$fn.closeWindow();
        this.$fn.search();
      }), errMsg => {
        this.$message.error(errMsg)
        console.log(errMsg);//具体的message信息，等同⽤$axios时的error.message
      }
    },
    checkForm() {
      if (this.change_item_id == null || this.change_item_id === '') {
        this.$message.error("请选择异动项目！");
        return false;
      }
      if (this.active_date == null || this.active_date === '') {
        this.$message.error("请选择生效月份！");
        return false;
      }
      if (this.employee_no == null || this.employee_no === '') {
        this.$message.error("请输入员工工号！");
        return false;
      }
      if (this.salary_change.after_salary_basic == null || this.salary_change.after_salary_basic === '' ||
          this.salary_change.after_salary_merit == null || this.salary_change.after_salary_merit === '' ||
          this.salary_change.after_salary_job_allowance == null || this.salary_change.after_salary_job_allowance === ''
          || this.salary_change.after_salary_meal == null || this.salary_change.after_salary_meal === '' ||
          this.salary_change.after_salary_phone == null || this.salary_change.after_salary_phone === ''
      ) {
        this.$message.error("请将薪资调整填写完整！");
        return false;
      }

      return true;
    },

    async getData() {
      let params = {
        id: this.parentData.id
      }
      if (params.id !== undefined) {
        let data = await this.$http("employeeChangeRecordService.getEmpChangeRecordData", params);
        this.change_item_id = data.change_item_id
        this.remark = data.remark
        this.active_date = data.active_date
        this.employee_no = data.employee_no
        this.employee_name = data.employee_name
        this.salary_change.before_salary_basic = data.before_salary_basic
        this.salary_change.after_salary_basic = data.after_salary_basic
        this.salary_change.before_salary_merit = data.before_salary_merit
        this.salary_change.after_salary_merit = data.after_salary_merit
        this.salary_change.before_salary_job_allowance = data.before_salary_job_allowance
        this.salary_change.after_salary_job_allowance = data.after_salary_job_allowance
        this.salary_change.before_salary_award = data.before_salary_award
        this.salary_change.after_salary_award = data.after_salary_award
        this.salary_change.before_salary_meal = data.before_salary_meal
        this.salary_change.after_salary_meal = data.after_salary_meal
        this.salary_change.before_salary_phone = data.before_salary_phone
        this.salary_change.after_salary_phone = data.after_salary_phone
        this.file_id = data.file_id
        this.active_date = data.active_date
      }
    },

    //获取新增和编辑的异动类型下拉框
    async getAddChangeOptionsOptions() {
      await this.$http("employeeHRService.getChangeItemTypeList").then(data => {
        this.options.change_item_options = data.filter(item => item.name !== '入职' && item.name !== '离职' && item.name !== '转正');
      })
    },
    //获取详细的异动类型下拉框
    async getDetailChangeOptionsOptions() {
      let data = await this.$http("employeeHRService.getChangeItemTypeList");
      this.options.change_item_options = data
    },

    async employeeNoChange() {
      if (this.employee_no === '') {
        return
      }
      let params = {
        employee_no: this.employee_no
      }
      let data = await this.$http("employeeChangeRecordService.getChangeRecordFromEmployeeNo", params);
      if (!data) {
        this.$message.error("该员工不存在或已离职！");
        this.employee_name = ''
        this.salary_change.before_salary_basic = ''
        this.salary_change.before_salary_merit = ''
        this.salary_change.before_salary_job_allowance = ''
        this.salary_change.before_salary_award = ''
        this.salary_change.before_salary_meal = ''
        this.salary_change.before_salary_phone = ''
        return
      }
      this.employee_name = data.employee_name
      this.salary_change.before_salary_basic = data.salary_basic
      this.salary_change.before_salary_merit = data.salary_merit
      this.salary_change.before_salary_job_allowance = data.salary_job_allowance
      this.salary_change.before_salary_award = data.salary_award
      this.salary_change.before_salary_meal = data.salary_meal
      this.salary_change.before_salary_phone = data.salary_phone
    },
  },
  created() {
    if (this.componentParam === "employee_change_record_detail") {
      this.getData().then(() => {
        this.getAttachments();
      })
      this.getDetailChangeOptionsOptions()
      this.isDetail = true
    } else if (this.componentParam === "employee_change_record_edit") {
      this.getData().then(() => {
        this.getAttachments();
      })
      this.getAddChangeOptionsOptions()
      this.isEdit = true
    } else {
      this.getAddChangeOptionsOptions()
    }
  },
}
</script>

<style scoped lang="less">
.box {
  padding-top: 10px;
  border: 1px solid black;
  border-radius: 5px;
  border-color: #cccccc;
  margin: 10px 0;
}

.checkbox-group {
  display: flex;
  flex-direction: column;
}

.custom-label {
  font-size: 16px;
  font-weight: bold;
}


</style>